<template>
  <div class="p-4 rounded-lg shadow-sm bg-white">
    <div class="flex items-center justify-between">
      <el-tabs v-model="selectedFeatureId">
        <el-tab-pane
          v-for="feature in AudienceFeature"
          :key="feature.id"
          :label="feature.name"
          :name="feature.id"
        ></el-tab-pane>
      </el-tabs>
      <ChartSelect v-model="yAxisField" />
    </div>

    <div class="bg-gray-50 border border-gray-200 flex items-center justify-center mb-6">
      <EchartCon
        chartType="bar"
        :data="chartData"
        :yAxisField="yAxisField"
      />
    </div>

    <CommonTable
      :table-data="tableData"
      :name-column-props="{
        prop: 'name',
        label: currentFeatureName,
        width: '160px',
      }"
      :show-status="true"
      :currency="currency"
    ></CommonTable>
  </div>
</template>

<script>
import { AudienceFeature, getTableData } from '../index';
import EchartCon from './EchartCon.vue';
import ChartSelect from './ChartSelect.vue';
import CommonTable from './CommonTable.vue';
export default {
  name: 'AgeGroupChart',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          age: {
            detailReports: {},
            summaryMetrics: {},
            estimateMetrics: {},
            adGroupMetrics: {},
            currencySign: '$',
          },
          gender: {
            detailReports: {},
            summaryMetrics: {},
            estimateMetrics: {},
            adGroupMetrics: {},
            currencySign: '$',
          },
          income: {
            detailReports: {},
            summaryMetrics: {},
            estimateMetrics: {},
            adGroupMetrics: {},
            currencySign: '$',
          },
          parental: {
            detailReports: {},
            summaryMetrics: {},
            estimateMetrics: {},
            adGroupMetrics: {},
            currencySign: '$',
          },
        };
      },
    },
  },
  components: {
    EchartCon,
    ChartSelect,
    CommonTable,
  },
  data() {
    return {
      AudienceFeature,
      selectedFeatureId: 'age',
      yAxisField: ['spend', 'conversions'],
    };
  },
  computed: {
    currency() {
      return this.currentData?.currencySign || '$';
    },
    currentFeatureName() {
      const feature = this.AudienceFeature.find((f) => f.id === this.selectedFeatureId);
      return feature ? feature.name : '';
    },
    currentData() {
      console.log(this.data, 'this.datathis.datathis.data');
      return (
        this.data?.[this.selectedFeatureId] || {
          detailReports: {},
          summaryMetrics: {},
          estimateMetrics: {},
          adGroupMetrics: {},
          currencySign: '$',
        }
      );
    },
    chartData() {
      return this.currentData.detailReports.map((v) => {
        return {
          ...v,
          ...v.metrics,
          date: v.name,
        };
      });
    },
    tableData() {
      return getTableData(this.currentData);
    },
  },
};
</script>

<style scoped>
:deep(.el-tabs__header) {
  border-bottom: none;
}

:deep(.el-tabs__nav-wrap::after) {
  display: none;
}

:deep(.el-tabs__item) {
  color: #9ca3af;
  border: none;
}

:deep(.el-tabs__item.is-active) {
  color: #3b82f6;
  border: none;
  font-weight: bold;
}

:deep(.el-tabs__active-bar) {
  display: none;
}
</style>
